import { render, staticRenderFns } from "./LikeNotification.vue?vue&type=template&id=e885882a&"
import script from "./LikeNotification.vue?vue&type=script&lang=ts&"
export * from "./LikeNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports